export default {
  manufacturerDeleteTitle: "Hersteller löschen",
  manufacturerDeleteMessage: "Möchten Sie diesen Hersteller wirklich löschen?",
  manufacturerDeleteNotPossibleTitle:
    "Hersteller, die mit einem Anlagenmodell verknüpft sind, können nicht gelöscht werden",
};
